/**
 * Libraries provided by TAL to consuming apps.
 */

import React from "react";
import ReactDOM from "react-dom";
import * as ReactJsxRuntime from "react/jsx-runtime";
import * as ReactJsxDevRuntime from "react/jsx-dev-runtime";
import * as sc5 from "styled-components";
import * as emotionReact from "@emotion/react";
import * as emotionCache from "@emotion/cache";
import * as emotionStyled from "@emotion/styled";
import { isOnServer } from "@origin-digital/tal-common";

window["React"] = React;
window["ReactDOM"] = ReactDOM;
window["sc5"] = sc5;
window["@emotion/react"] = emotionReact;
window["@emotion/cache"] = emotionCache;
window["@emotion/styled"] = emotionStyled;

// This is for react 19 upgrade.
window["react/jsx-runtime"] = ReactJsxRuntime;
window["react/jsx-dev-runtime"] = ReactJsxDevRuntime;

// Client-only: create a single Emotion cache so tal-client and app (in tal-core boot.js) share it.
// tal-core SSR injects style tags with data-emotion="css ..."; createCache with key "css" rehydrates
// from those tags (see @emotion/cache), so the client reuses the server's styles and appends new ones.
// Client-only: typeof window guards Node; isOnServer() guards JSDOM (appSSR).
if (
  typeof window !== "undefined" &&
  !isOnServer() &&
  !(window as any).__emotionCache
) {
  const emotionInsertionPoint = document.getElementById(
    "emotion-insertion-point"
  );
  (window as any).__emotionCache = emotionCache.default({
    key: "css",
    prepend: true,
    ...(emotionInsertionPoint ? { insertionPoint: emotionInsertionPoint } : {}),
  });
}

export {};
